export enum BlogPostStatusEnum {
    DRAFT = 'draft',
    PUBLIC = 'public'
}

export interface BlogPost {
    id: number;
    title: string;
    content: string;
    status: BlogPostStatusEnum;
    slug: string;
    mainImageName: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface BlogPostFormData extends FormData {
    append(name: 'title' | 'content' | 'status' | 'mainImageFile', value: string | Blob): void;
} 